var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qrcode-vue',{attrs:{"value":_vm.value,"size":_vm.size,"level":"H","render-as":"canvas"}})}
var staticRenderFns = []

export { render, staticRenderFns }